import ApplicationConstants from './constants';
import * as D from './deps';
import ApplicationReducer from './reducers/Application';
import DeviceReducer from './reducers/Device';
import IdleMonitorReducer from './reducers/IdleMonitor';
import RunTimeConfigReducer from './reducers/RunTimeConfig';
import ApplicationWatchers from './sagas/watchers';
import { initializeApplication } from './sagas/workers';
import * as ApplicationUtils from './utils';

const appModule = D.createDomainModule({
  name: ApplicationConstants.DOMAIN_NAME,
  constants: ApplicationConstants,
  utils: ApplicationUtils,
  components: null,
  reducer: {
    application: ApplicationReducer,
    idle: IdleMonitorReducer,
    device: DeviceReducer,
    runTimeConfig: RunTimeConfigReducer,
  },
  persisted: true,
  persistedReducers: ['device'],
  onLoad(store) {
    return this.runSaga(store, initializeApplication).toPromise();
  },
  onStart() {
    this.registeredHandlers = D.registerHandlers(ApplicationWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});

export default appModule;
